export const INLINE_STYLE_BUTTONS = [
  { label: 'Negrito', style: 'BOLD' },
  { label: 'Itálico', style: 'ITALIC' },
  { label: 'Tachado', style: 'STRIKETHROUGH' },
  { label: 'Espaçado', style: 'CODE' },
  { label: 'Sublinhado', style: 'UNDERLINE' }
]

export const BLOCK_TYPE_DROPDOWN = [
  { label: 'Normal', style: 'unstyled' },
  { label: 'Título 1', style: 'header-one' },
  { label: 'Título 2', style: 'header-two' },
  { label: 'Título 3', style: 'header-three' },
  { label: 'Bloco', style: 'code-block' }
]
export const BLOCK_TYPE_BUTTONS = [
  { label: 'Lista com marcadores', style: 'unordered-list-item' },
  { label: 'Lista numerada', style: 'ordered-list-item' },
  { label: 'Citar', style: 'blockquote' }
]

const EditorToolbarConfig = {
  display: []
}

export default EditorToolbarConfig
